<template>
  <div class="submissions">
    <div class="hidden-sm-and-down">
      <v-alert v-if="action_success_msg" type="success" tile>
        {{action_success_msg}}
      </v-alert>
      <v-alert v-if="action_error_msg" type="error">
        {{action_error_msg}}
      </v-alert>
      <template>
        <v-card dark class="mt-2">
          <v-card-title>
            <v-card flat>
              <v-card-text class="py-0 px-1">
                <v-row>
                  <v-switch
                    v-model="advanced_view"
                    label="Advanced View"
                    class="mt-2 mr-2"
                  ></v-switch>
                  <v-btn-toggle class="mt-3" mandatory rounded v-model="grouped_view">
                    <v-btn :value="true" class="px-2" min-width="32px" small color="primary" title="Grouped Listing" @click="load_group_listing(this)">
                      <v-icon small>mdi-format-align-center</v-icon>
                    </v-btn>
                    <v-btn :value="false" class="px-2" min-width="32px" small color="primary" title="Flat Listing" @click="load_flat_listing(this)">
                      <v-icon small>mdi-format-align-justify</v-icon>
                    </v-btn>
                  </v-btn-toggle>
                </v-row>
              </v-card-text>
            </v-card>
            <v-btn
              v-if="grouped_view" small depressed class="ml-4" :disabled="!selected.length"
              color="warning" @click="hide_selected"
            >
              Hide
            </v-btn>
            <v-chip v-if="grouped_view" class="ml-2 px-0 py-3" label outlined small>
              <v-checkbox
                v-model="all_submissions"
                label="Show All"
                value="1"
                class="pa-0 my-0 mx-2 caption"
                hide-details
                @change="set_visbility"
              ></v-checkbox>
            </v-chip>
            <v-text-field
              clearable
              v-model="search"
              append-icon="search"
              :label="search_placeholder"
              single-line
              hide-details
              class="py-0 my-0 ml-4"
              height="24px"
              v-on:keyup.enter="search_job"
              v-on:click:clear="clear_search"
              expand-icon="chevron_right"
            ></v-text-field>
            <v-select
              v-model="selected_status"
              solo
              flat
              :items="filter_items"
              item-text="filter_text"
              item-value="filter_val" 
              dense
              multiple
              label="Status"
              class="pb-1 ml-3"
              prepend-inner-icon="mdi-filter"
              hide-details
              clearable
              color="primary"
              outlined
              @input="set_status_filter"
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0">
                  <span>{{ item.filter_text }}</span>
                </v-chip>
                <span
                  v-if="index === 1"
                  class="grey--text caption"
                >(+{{ selected_status.length - 1 }} others)</span>
              </template>
            </v-select>
          </v-card-title>
        </v-card>
      </template>
      <v-row v-if="grouped_view && !mobile_view" no-gutters>
        <v-col :cols="advanced_view ? 7 : 12" :style="`height:${avail_height};overflow:scroll`">
          <v-data-table
            v-model="selected"
            :headers="group_view_headers"
            :items="projects"
            :server-items-length="total_projects"
            item-key="id"
            :loading="loading"
            show-select
            class="elevation-1"
            :search="search"
            :options.sync="pagination"
            :single-expand="singleExpand"
            :expanded.sync="expanded"
            show-expand
            dense
            :footer-props="{
              'items-per-page-options': [50, 100, 200, 300, 400, 500]
            }"
            @click:row="expand_row"
          >
            <template slot="no-data">
              No matching submissions
            </template>

            <template slot="loading">
              Loading...
            </template>

            <template v-slot:item.data-table-expand="{ item, expand, isExpanded }">
              <v-icon v-if="isExpanded">mdi-chevron-down</v-icon>
              <v-icon v-else>mdi-chevron-right</v-icon>
            </template>
            <template v-slot:item.name="{ item }">
              <v-btn v-if="item.status == 'Completed'" fab dark x-small color="primary" class="mx-1 sub_status">
                <v-icon x-small>check_circle_outline</v-icon>
              </v-btn>
              <v-btn v-if="item.status == 'Active' || item.status == 'Running'" fab dark x-small color="success" class="mx-1 sub_status">
                <v-icon x-small>play_circle_outline</v-icon>
              </v-btn>
              <v-btn v-if="item.status == 'Stopped' || item.status == 'Stopping'" fab dark x-small color="warning" class="mx-1 sub_status">
                <v-icon x-small>error_outline</v-icon>
              </v-btn>
              <v-btn v-if="item.status == 'Terminated' || item.status == 'Terminating'" fab dark x-small color="warning" class="mx-1 sub_status">
                <v-icon x-small>error_outline</v-icon>
              </v-btn>
              <v-btn v-if="item.status == 'Suspended' || item.status == 'Suspending'" fab dark x-small color="warning" class="mx-1 sub_status">
                <v-icon x-small>error_outline</v-icon>
              </v-btn>
              <v-btn v-if="item.status == 'Failed' || item.status == 'Failing'" fab dark x-small color="error" class="mx-1 sub_status">
                <v-icon x-small>remove_circle_outline</v-icon>
              </v-btn>
              <v-btn v-if="item.status == '' || item.status == 'Starting' || item.status == 'Blocked' || item.status == 'Waiting'" fab dark x-small color="grey" class="mx-1 sub_status">
                <v-icon x-small>help_outline</v-icon>
              </v-btn>
              <v-chip x-small class="pa-3">
                {{item.name}}sss
                {{item.submission_name}}
              </v-chip>
              <br/>
              {{item.description}}
            </template>

            <template v-slot:item.jobs="{ item }">
              <v-btn class="mx-1" height="18px" width="18px" fab depressed x-small color="blue">
                {{ (item.jobs && item.jobs.length) || 0 }}
              </v-btn>
            </template>

            <template v-slot:item.created="{ item }">
              {{ (item.created && to_local_datetime(item.created)) || "-" }}
            </template>

            <template v-slot:item.durations_mins="{ item }">
              {{ item.duration }}
            </template>

            <template v-slot:item.credits_consumed="{ item }">
              {{ item.credits_consumed && item.credits_consumed.toFixed(2) }}
            </template>

            <template v-slot:item.actions="{ item }">
              <v-btn
                fab dark height="18px" width="18px" x-small color="green" class="mx-1"
                title="View Summary" @click.stop="show_submission_summary(item)"
              >
                <v-icon x-small>assignment</v-icon>
              </v-btn>
              <v-btn
                v-if="stop_project_whitelist.indexOf(item.status) > -1"
                fab dark height="18px" width="18px" x-small color="error" class="ml-1"
                @click.stop="stop_project_dialog=true;stop_project_obj=item;"
              >
                <v-icon x-small>remove_circle_outline</v-icon>
              </v-btn>
            </template>

            <template v-slot:expanded-item="headers">
              <td colspan="10" class="pa-0" v-if="advanced_view">
                <div class="px-0 job_headers">
                  <v-card flat class="rounded-0">
                    <v-row no-gutters class="pa-1">
                      <v-flex lg3>
                        <div class="caption grey--text">Job Name/ID</div>
                      </v-flex>
                      <v-flex lg2>
                        <div class="caption grey--text text-center">Status</div>
                      </v-flex>
                      <v-flex lg2>
                        <div class="caption grey--text">Application</div>
                      </v-flex>
                      <v-flex lg1>
                        <div class="caption grey--text">Machine Type</div>
                      </v-flex>
                      <v-flex lg1>
                        <div class="caption grey--text">Progress</div>
                      </v-flex>
                      <v-flex lg1>
                        <div class="caption grey--text text-right">Duration</div>
                      </v-flex>
                      <v-flex lg1>
                        <div class="caption grey--text text-right">Credits</div>
                      </v-flex>
                      <v-flex lg1>
                        <div class="caption grey--text justify-center layout">Actions</div>
                      </v-flex>
                    </v-row>
                    <v-divider></v-divider>
                  </v-card>
                </div>

                <div v-for="job in headers.item.jobs" v-bind:key="job.id" :class="`px-0 jobs ${job.status}`">
                <v-card flat @click="show_job_details(job)">
                  <v-row no-gutters class="pa-1">
                    <v-flex lg3>
                      <div>
                        <span class="font-weight-bold">{{job.name}}</span>
                        <br/>
                        <span class="job_id">{{job._id}}</span>
                      </div>
                    </v-flex>
                    <v-flex lg2>
                      <div class="text-center">
                        <v-chip :class="`status mx-0 ${job.status}`" x-small text-color="white" :title="job.status_message">
                          {{job.status}}
                          <v-icon v-if="job.status_message && job.status_message != ''" right x-small color="warning">info</v-icon>
                        </v-chip>
                      </div>
                    </v-flex>
                    <v-flex lg2>
                      <div>
                        {{job.product_name}}
                      </div>
                    </v-flex>
                    <v-flex lg1>
                      <div>
                        {{job.machine_type}}
                      </div>
                    </v-flex>
                    <v-flex lg1>
                      <div v-if="job.tasks_total == 1 && job.status != 'Starting'" class="text-center">
                        See log
                      </div>
                      <div v-if="job.tasks_total > 1 && job.status != 'Starting'" class="text-center">
                        <v-progress-circular :rotate="-90" :size="32" :width="3" :value="job.progress_percentage" :class="`${job.status}`">
                          {{job.progress_percentage}}%
                        </v-progress-circular>
                      </div>
                      <div v-if="job.status == 'Starting'" class="text-center">
                        <v-progress-circular :rotate="-90" :size="32" :width="3" :value="job.sync_progress_percentage" :class="`${job.status}`">
                          {{job.sync_progress_percentage}}%
                        </v-progress-circular>
                        Synching
                      </div>
                    </v-flex>
                    <v-flex lg1>
                      <div class="text-right">
                        {{job.duration}}
                        <div v-if="job.status == 'Running' && job.tasks_completed > 0">
                          <v-chip color="primary" x-small>{{job.duration_estimate}}</v-chip>
                        </div>
                      </div>
                    </v-flex>
                    <v-flex lg1>
                      <div class="text-right">
                        {{job.credits_consumed && job.credits_consumed.toFixed(2)}}
                        <div v-if="job.status == 'Running' && job.tasks_completed > 0">
                          <v-chip color="primary" x-small>{{job.credits_estimate.toFixed(2)}}</v-chip>
                        </div>
                      </div>
                    </v-flex>
                    <v-flex lg1>
                      <div class="job_actions justify-center layout">
                        <v-btn
                          v-if="force_start_job_whitelist.indexOf(job.status) > -1"
                          fab dark height="18px" width="18px" x-small
                          color="green" class="ml-1" title="Force Start Job"
                          @click.stop="force_start_job(job);"
                        >
                          <v-icon x-small>play_circle_outline</v-icon>
                        </v-btn>
                        <v-btn
                          v-if="restart_job_whitelist.indexOf(job.status) > -1"
                          fab dark height="18px" width="18px" x-small
                          color="green" class="ml-1" title="Restart all or specific tasks"
                          @click.stop="restart_job(job);"
                        >
                          <v-icon x-small>refresh</v-icon>
                        </v-btn>
                        <v-btn
                          v-if="stop_job_whitelist.indexOf(job.status) > -1"
                          fab dark height="18px" width="18px" x-small color="error" class="ml-1"
                          @click.stop="stop_job(job);"
                        >
                          <v-icon x-small>remove_circle_outline</v-icon>
                        </v-btn>
                      </div>
                    </v-flex>
                  </v-row>
                  <v-divider></v-divider>
                </v-card>
                </div>
              </td>
              <td colspan="10" class="pa-0" v-else>
                <div class="px-0 job_headers">
                  <v-card flat class="rounded-0">
                    <v-row no-gutters class="pa-1">
                      <v-flex lg2>
                        <div class="caption grey--text">Job Name/ID</div>
                      </v-flex>
                      <v-flex lg4>
                        <v-layout>
                          <v-flex lg4>
                            <div class="caption grey--text text-center">Status</div>
                          </v-flex>
                          <v-flex lg4>
                            <div class="caption grey--text">Application</div>
                          </v-flex>
                          <v-flex lg2>
                            <div class="caption grey--text">Requested</div>
                          </v-flex>
                          <v-flex lg2>
                            <div class="caption grey--text">Started</div>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex lg3>
                        <v-layout>
                          <v-flex lg4>
                            <div class="caption grey--text">Machine Type</div>
                          </v-flex>
                          <v-flex lg5>
                            <div class="caption grey--text">Tasks/Done/Failed<br/>Average Task Time</div>
                          </v-flex>
                          <v-flex lg2>
                            <div class="caption grey--text">Progress</div>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex lg3>
                        <v-layout>
                          <v-flex lg3>
                            <div class="caption grey--text">Ended</div>
                          </v-flex>
                          <v-flex lg3>
                            <div class="caption grey--text text-right">Duration</div>
                          </v-flex>
                          <v-flex lg2>
                            <div class="caption grey--text text-right">Credits</div>
                          </v-flex>
                          <v-flex lg4>
                            <div class="caption grey--text justify-center layout">Actions</div>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-row>
                    <v-divider></v-divider>
                  </v-card>
                </div>

                <div v-for="job in headers.item.jobs" v-bind:key="job.id" :class="`px-0 jobs ${job.status}`">
                <v-card flat @click="show_job_details(job)">
                  <v-row no-gutters class="pa-1">
                    <v-flex lg2>
                      <div>
                        <span class="font-weight-bold">{{job.name}}</span>
                        <br/>
                        <span class="job_id">{{job._id}}</span>
                      </div>
                    </v-flex>
                    <v-flex lg4>
                      <v-layout>
                        <v-flex lg4>
                          <div class="caption text-center">
                            <v-chip :class="`status mx-0 ${job.status}`" x-small text-color="white" :title="job.status_message">
                              {{job.status}}
                              <v-icon v-if="job.status_message && job.status_message != ''" right x-small color="warning">info</v-icon>
                            </v-chip>
                          </div>
                        </v-flex>
                        <v-flex lg4>
                          <div>
                            {{job.product_name}}
                          </div>
                        </v-flex>
                        <v-flex lg2>
                          <div>{{ (job.created && to_local_datetime(job.created)) || "-" }}</div>
                        </v-flex>
                        <v-flex lg2>
                          <div>{{ (job.start && to_local_datetime(job.start)) || "-" }}</div>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex lg3>
                      <v-layout>
                        <v-flex lg4>
                          <div color="error">{{job.machine_type}}</div>
                        </v-flex>
                        <v-flex lg5>
                          <div>
                            {{job.tasks_total}}/{{job.tasks_completed}}/{{job.tasks_failed}}
                            <br/>
                            {{job.tasks_completed_duration_avg}}
                          </div>
                        </v-flex>
                        <v-flex lg3>
                          <div v-if="job.tasks_total == 1 && job.status != 'Starting'" class="text-center">
                            See log
                          </div>
                          <div v-if="job.tasks_total > 1 && job.status != 'Starting'" class="text-center">
                            <v-progress-circular :rotate="-90" :size="32" :width="3" :value="job.progress_percentage" :class="`${job.status}`">
                              {{job.progress_percentage}}%
                            </v-progress-circular>
                          </div>
                          <div v-if="job.status == 'Starting'" class="text-center">
                            <v-progress-circular :rotate="-90" :size="32" :width="3" :value="job.sync_progress_percentage" :class="`${job.status}`">
                              {{job.sync_progress_percentage}}%
                            </v-progress-circular>
                            Synching
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex lg3>
                      <v-layout>
                        <v-flex lg3>
                          <div>{{ (job.end && to_local_datetime(job.end)) || "-" }}</div>
                        </v-flex>
                        <v-flex lg3>
                          <div class="text-right">
                            {{job.duration}}
                            <div v-if="job.status == 'Running' && job.tasks_completed > 0">
                              <v-chip color="primary" x-small>{{job.duration_estimate}}</v-chip>
                            </div>
                          </div>
                        </v-flex>
                        <v-flex lg2>
                          <div class="text-right">
                            {{job.credits_consumed && job.credits_consumed.toFixed(2)}}
                            <div v-if="job.status == 'Running' && job.tasks_completed > 0">
                              <v-chip color="primary" x-small>{{job.credits_estimate.toFixed(2)}}</v-chip>
                            </div>
                          </div>
                        </v-flex>
                        <v-flex lg4>
                          <div class="job_actions justify-center layout">
                            <v-btn
                              v-if="force_start_job_whitelist.indexOf(job.status) > -1"
                              fab dark height="18px" width="18px" x-small
                              color="green" class="ml-1" title="Force Start Job"
                              @click.stop="force_start_job(job);"
                            >
                              <v-icon x-small>play_circle_outline</v-icon>
                            </v-btn>
                            <v-btn
                              v-if="restart_job_whitelist.indexOf(job.status) > -1"
                              fab dark height="18px" width="18px" x-small
                              color="green" class="ml-1" title="Restart all or specific tasks"
                              @click.stop="restart_job(job);"
                            >
                              <v-icon x-small>refresh</v-icon>
                            </v-btn>
                            <v-btn
                              v-if="stop_job_whitelist.indexOf(job.status) > -1"
                              fab dark height="18px" width="18px" x-small color="error" class="ml-1"
                              @click.stop="stop_job(job);"
                            >
                              <v-icon x-small>remove_circle_outline</v-icon>
                            </v-btn>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-row>
                  <v-divider></v-divider>
                </v-card>
                </div>
              </td>
            </template>
          </v-data-table>
          <template>
            <v-dialog v-model="loading_summary" persistent width="300">
              <v-card color="primary" dark>
                <v-card-text>
                  Retrieving summary...
                  <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
              </v-card>
            </v-dialog>
            <v-dialog v-model="show_summary" scrollable fullscreen hide-overlay transition="dialog-bottom-transition">
              <v-card color="#303030">
                <v-toolbar dense height="36px">
                  <v-toolbar-title class="subtitle-1 font-weight-medium">Summary</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn icon x-small @click="show_summary=false;">
                    <v-icon>close</v-icon>
                  </v-btn>
                </v-toolbar>
                <v-card-text class="pa-0">
                  <v-container fluid class="pa-0 ma-0">
                    <v-row no-gutters class="ma-4">
                      <v-col cols="12" class="pa-0 body-2">
                        <pre>
                          {{submission_summary || "Summary not found"}}
                        </pre>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog>
          </template>
        </v-col>
        <v-col v-if="advanced_view" cols="5" :style="`height:${avail_height};overflow:scroll;border:3px solid grey`">
          <JobDetails
            v-if="job_details_obj"
            :advanced_view="advanced_view"
            :job_details_obj="job_details_obj"
            :update_job_details_obj="update_job_details_obj"
            :close_job_details_dialog="close_job_details_dialog"
            :refresh_parent="refresh_parent"
            :to_local_datetime="to_local_datetime"
            :force_start_job_whitelist="force_start_job_whitelist"
            :stop_job_whitelist="stop_job_whitelist"
            :restart_job_whitelist="restart_job_whitelist"
            :force_start_job="force_start_job"
            :restart_job="restart_job"
            :stop_job="stop_job"
          />
        </v-col>
      </v-row>
      <v-row v-if="!grouped_view && !mobile_view" no-gutters>
        <v-col :cols="advanced_view ? 7 : 12" :style="`height:${avail_height};overflow:scroll`">
          <v-data-table
            dense
            :headers="advanced_view ? flat_view_headers_advanced : flat_view_headers"
            :items="projects"
            class="elevation-1 ungrouped-table"
            :server-items-length="total_projects"
            :search="search"
            :options.sync="pagination"
            item-key="id"
            :loading="loading"
            :footer-props="{
              'items-per-page-options': [50, 100, 200, 300, 400, 500]
            }"
            @click:row="row_clicked"
          >
            <template slot="no-data">
              No matching jobs
            </template>

            <template slot="loading">
              Loading...
            </template>

            <template v-slot:item.icon="{ item }">
              <div>
                <v-btn v-if="item.status == 'Completed'" fab dark x-small color="primary" class="left mx-0 sub_status">
                  <v-icon x-small>check_circle_outline</v-icon>
                </v-btn>
                <v-btn v-if="item.status == 'Active' || item.status == 'Running'" fab dark x-small color="success" class="mx-0 sub_status">
                  <v-icon x-small>play_circle_outline</v-icon>
                </v-btn>
                <v-btn v-if="item.status == 'Terminated' || item.status == 'Terminating'" fab dark x-small color="warning" class="mx-0 sub_status">
                  <v-icon x-small>error_outline</v-icon>
                </v-btn>
                <v-btn v-if="item.status == 'Stopped' || item.status == 'Stopping'" fab dark x-small color="warning" class="mx-0 sub_status">
                  <v-icon x-small>error_outline</v-icon>
                </v-btn>
                <v-btn v-if="item.status == 'Suspended' || item.status == 'Suspending'" fab dark x-small color="warning" class="mx-0 sub_status">
                  <v-icon x-small>error_outline</v-icon>
                </v-btn>
                <v-btn v-if="item.status == 'Failed' || item.status == 'Failing'" fab dark x-small color="error" class="mx-0 sub_status">
                  <v-icon x-small>remove_circle_outline</v-icon>
                </v-btn>
                <v-btn v-if="item.status == '' || item.status == 'Starting' || item.status == 'Blocked' || item.status == 'Waiting'" fab dark x-small color="grey" class="mx-0 sub_status">
                  <v-icon x-small>help_outline</v-icon>
                </v-btn>
              </div>
            </template>

            <template v-slot:item.name="{ item }">
              {{ item.project_name }} {{item.name}}<br/>
              <span>{{item._id}}</span>
            </template>

            <template v-slot:item.product_name="{ item }">
              {{ item.product_name }}
            </template>

            <template v-slot:item.status="{ item }">
              <v-chip :class="`status mx-0 ${item.status}`" x-small text-color="white" :title="item.status_message">
                {{item.status}}
                <v-icon v-if="item.status_message && item.status_message != ''" right x-small color="warning">info</v-icon>
              </v-chip>
            </template>

            <template v-slot:item.created="{ item }">
              {{ (item.created && to_local_datetime(item.created)) || "-" }}
            </template>

            <template v-slot:item.start="{ item }">
              {{ (item.start && to_local_datetime(item.start)) || "-" }}
            </template>

            <template v-slot:item.tasks_total="{ item }">
              {{ item.tasks_total }}/{{ item.tasks_completed }}/{{ item.tasks_failed }}
            </template>

            <template v-slot:item.progress="{ item }">
              <div v-if="item.tasks_total == 1 && item.status != 'Starting'" class="text-center">
                See log
              </div>
              <div v-if="item.tasks_total > 1 && item.status != 'Starting'" class="text-center">
                <v-progress-circular :rotate="-90" :size="32" :width="3" :value="item.progress_percentage" :class="`${item.status}`">
                  {{item.progress_percentage}}%
                </v-progress-circular>
              </div>
              <div v-if="item.status == 'Starting'" class="text-center">
                <v-progress-circular :rotate="-90" :size="32" :width="3" :value="item.sync_progress_percentage" :class="`${item.status}`">
                  {{item.sync_progress_percentage}}%
                </v-progress-circular>
                Synching
              </div>
            </template>

            <template v-slot:item.end="{ item }">
              {{ (item.end && to_local_datetime(item.end)) || "-" }}
            </template>

            <template v-slot:item.duration_mins="{ item }">
              {{ item.duration }}
              <div v-if="item.status == 'Running' && item.tasks_completed > 0">
                <v-chip color="primary" x-small>{{item.duration_estimate}}</v-chip>
              </div>
            </template>

            <template v-slot:item.credits_consumed="{ item }">
              {{ item.credits_consumed && item.credits_consumed.toFixed(2) }}
              <div v-if="item.status == 'Running' && item.tasks_completed > 0">
                <v-chip color="primary" x-small>{{item.credits_estimate.toFixed(2)}}</v-chip>
              </div>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-btn
                v-if="force_start_job_whitelist.indexOf(item.status) > -1"
                fab dark height="18px" width="18px" x-small
                color="green" class="ml-1" title="Force Start Job"
                @click.stop="force_start_job(item);"
              >
                <v-icon x-small>play_circle_outline</v-icon>
              </v-btn>
              <v-btn
                v-if="restart_job_whitelist.indexOf(item.status) > -1"
                fab dark height="18px" width="18px" x-small color="green"
                class="ml-1" title="Restart all or specific tasks"
                @click.stop="restart_job(item);"
              >
                <v-icon x-small>refresh</v-icon>
              </v-btn>
              <v-btn
                v-if="stop_job_whitelist.indexOf(item.status) > -1"
                fab dark height="18px" width="18px" x-small color="error" class="ml-1"
                @click.stop="stop_job(item);"
              >
                <v-icon x-small>remove_circle_outline</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-col>
        <v-col v-if="advanced_view" cols="5" :style="`height:${avail_height};overflow:scroll;border:3px solid grey`">
          <JobDetails
            v-if="job_details_obj"
            :advanced_view="advanced_view"
            :job_details_obj="job_details_obj"
            :update_job_details_obj="update_job_details_obj"
            :close_job_details_dialog="close_job_details_dialog"
            :refresh_parent="refresh_parent"
            :to_local_datetime="to_local_datetime"
            :force_start_job_whitelist="force_start_job_whitelist"
            :stop_job_whitelist="stop_job_whitelist"
            :restart_job_whitelist="restart_job_whitelist"
            :force_start_job="force_start_job"
            :restart_job="restart_job"
            :stop_job="stop_job"
          />
        </v-col>
      </v-row>

      <v-dialog v-if="!advanced_view" v-model="job_details_dialog" persistent scrollable fullscreen hide-overlay transition="dialog-bottom-transition">
        <JobDetails
          v-if="job_details_obj"
          :advanced_view="advanced_view"
          :job_details_obj="job_details_obj"
          :update_job_details_obj="update_job_details_obj"
          :close_job_details_dialog="close_job_details_dialog"
          :refresh_parent="refresh_parent"
          :to_local_datetime="to_local_datetime"
          :force_start_job_whitelist="force_start_job_whitelist"
          :stop_job_whitelist="stop_job_whitelist"
          :restart_job_whitelist="restart_job_whitelist"
          :force_start_job="force_start_job"
          :restart_job="restart_job"
          :stop_job="stop_job"
        />
      </v-dialog>

      <StopProjectDialog
        :stop_project_dialog="stop_project_dialog"
        :stop_project_obj="stop_project_obj"
        :close_stop_project_dialog="close_stop_project_dialog"
        :refresh_parent="refresh_parent"
      />
      
      <RestartJobDialog
        v-if="restart_job_obj"
        :restart_job_dialog="restart_job_dialog"
        :restart_job_obj="restart_job_obj"
        :close_restart_job_dialog="close_restart_job_dialog"
        :refresh_parent="refresh_parent"
      />

      <StopJobDialog
        :stop_job_dialog="stop_job_dialog"
        :stop_job_obj="stop_job_obj"
        :close_stop_job_dialog="close_stop_job_dialog"
        :refresh_parent="refresh_parent"
      />

    </div>
    <div class="hidden-md-and-up">
      <v-row v-if="mobile_view" no-gutters>
        <v-col cols="12">
          <v-dialog v-model="loading_mobile" persistent width="300">
            <v-card color="primary" dark>
              <v-card-text>
                Loading jobs...
                <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
              </v-card-text>
            </v-card>
          </v-dialog>

          <v-list subheader two-line class="mt-4 mb-10">
            <template v-for="(project, index) in projects">
              <v-list-item
                :key="project._id"
                @click="row_clicked(project)"
                class="my-1 px-2"
              >
                <v-list-item-content class="pa-0 my-1">
                  <v-list-item-title>
                    <v-chip small>
                      {{ project.project_name }} {{project.name}}
                    </v-chip>
                    <v-chip :class="`status ml-1 ${project.status}`" small text-color="white" :title="project.status_message">
                      {{project.status}}
                    </v-chip>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{project._id}}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action v-if="force_start_job_whitelist.indexOf(project.status) > -1" class="ma-0">
                  <v-btn
                    fab dark height="18px" width="18px" x-small
                    color="green" title="Force Start Job"
                    @click.stop="force_start_job(project);"
                  >
                    <v-icon x-small>play_circle_outline</v-icon>
                  </v-btn>
                </v-list-item-action>
                <v-list-item-action v-if="restart_job_whitelist.indexOf(project.status) > -1" class="ma-0">
                  <v-btn
                    fab dark height="18px" width="18px" x-small color="green"
                    title="Restart all or specific tasks"
                    @click.stop="restart_job(project);"
                  >
                    <v-icon x-small>refresh</v-icon>
                  </v-btn>
                </v-list-item-action>
                <v-list-item-action v-if="stop_job_whitelist.indexOf(project.status) > -1" class="ma-0">
                  <v-btn
                    fab dark height="18px" width="18px" x-small color="error"
                    @click.stop="stop_job(project);"
                  >
                    <v-icon x-small>remove_circle_outline</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
              <v-divider
                v-if="index < projects.length - 1"
                :key="index"
              ></v-divider>
            </template>
          </v-list>

          <v-footer app padless>
            <div class="text-center flex-grow-1">
              <v-pagination
                v-model="page"
                :length="page_length"
                :total-visible="total_visible"
                @input="load_page"
              ></v-pagination>
            </div>
          </v-footer>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import JobDetails from './JobDetails';
import StopProjectDialog from './StopProjectDialog';
import RestartJobDialog from './RestartJobDialog';
import StopJobDialog from './StopJobDialog';

export default {
  name: "Submissions",
  components: {
    JobDetails,
    StopProjectDialog,
    RestartJobDialog,
    StopJobDialog
  },
  props:{
    project: {
      type: String
    }
  },
  data() {
    return {
      page: 1,
      itemsPerPage: 50,
      page_length: 1,
      total_visible: 1,
      advanced_view: this.$store.getters.userLoggedIn.advanced_view,
      avail_height: "520px",
      filter_items: [
        {filter_text: "Completed", filter_val: "'Completed'"},
        {filter_text: "Stopped", filter_val: "'Stopped'"},
        {filter_text: "Failed", filter_val: "'Failed'"},
        {filter_text: "Suspended", filter_val: "'Suspended'"},
        {filter_text: "Running", filter_val: "'Running'"},
        {filter_text: "Starting", filter_val: "'Starting'"},
        {filter_text: "Stopping", filter_val: "'Stopping'"},
        {filter_text: "Suspending", filter_val: "'Suspending'"}
      ],
      selected_status: [],
      all_submissions: 0,
      service_plan: "",
      credits_available: 0,
      action_success_msg: null,
      action_error_msg: null,
      expanded: [],
      grouped_view: !this.$store.getters.userLoggedIn.flat_view,
      mobile_view: false,
      expandedRef: {},
      singleExpand: false,
      local_time_str: "",
      utc_time_str: "",
      show_summary: false,
      loading_summary: false,
      submission_summary: null,
      dialog: false,
      job_details_dialog: false,
      job_details_obj: null,
      stop_project_whitelist: ['Blocked', 'Pending', 'Starting', 'Running', 'Waiting', 'Suspending'],
      stop_project_dialog: false,
      stop_project_obj: null,
      force_start_job_whitelist: ['Blocked', 'Waiting'],
      stop_job_whitelist: ['Blocked', 'Pending', 'Starting', 'Running', 'Waiting', 'Suspending'],
      stop_job_dialog: false,
      stop_job_obj: null,
      restart_job_whitelist: ['Completed', 'Failed', 'Terminated', 'Suspended', 'Stopped'],
      restart_job_dialog: false,
      restart_job_obj: null,
      stop_task_dialog: false,
      stop_task_mobile: false,
      stop_task_obj: null,
      is_mobile: false,
      tasks_tout: null,
      jobs_tout: null,      
      pagination: {
        page: 1,
        itemsPerPage: 50,
        totalItems: 1
      },
      search: '',
      search_placeholder: "Search by submission name",
      selected: [],
      projects: [],
      total_projects: 0,
      expand: false,
      loading: true,
      loading_mobile: true,
      job_loading: false,
      job_items: [],
      group_view_headers: [
        { text: 'Submission ', value: 'name', filterable: true },
        { text: 'Jobs', value: 'jobs', align: 'center', sortable: false },
        { text: 'Requested', value: 'created' },
        { text: 'Duration', value: 'durations_mins', align: 'right', sortable: false },
        { text: 'Credits', value: 'credits_consumed', align: 'right', sortable: false },
        { text: 'Actions', value: 'actions', align: 'center', sortable: false },
      ],
      flat_view_headers: [
        { text: ' ', value: 'icon' },
        { text: 'Job Name/ID', value: 'name' },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Application', value: 'product_name', sortable: false },
        { text: 'Machine Type', value: 'machine_type', sortable: false },
        { text: 'Tasks/Done/Fail', value: 'tasks_total', sortable: false },
        { text: 'Requested', value: 'created', class: 'datetime' },
        { text: 'Started', value: 'start', class: 'datetime' },
        { text: 'Progress', value: 'progress', align: 'center', sortable: false },
        { text: 'Ended', value: 'end', class: 'datetime' },
        { text: 'Average Task Time', value: 'tasks_completed_duration_avg', sortable: false },
        { text: 'Duration', value: 'duration_mins', align: 'right', sortable: false },
        { text: 'Credits', value: 'credits_consumed', align: 'right', sortable: false },
        { text: 'Actions', value: 'actions', align: 'center', sortable: false, width: '64px' },
      ],
      flat_view_headers_advanced: [
        { text: ' ', value: 'icon' },
        { text: 'Job Name/ID', value: 'name' },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Application', value: 'product_name', sortable: false },
        { text: 'Machine Type', value: 'machine_type', sortable: false },
        { text: 'Progress', value: 'progress', sortable: false },
        { text: 'Duration', value: 'duration_mins', align: 'right', sortable: false },
        { text: 'Credits', value: 'credits_consumed', align: 'right', sortable: false },
        { text: 'Actions', value: 'actions', align: 'center', sortable: false, width: '64px' },
      ],
      selected_job : {'created': "",'end': "",'credits_consumed':0},
      selected_task : null
    }
  },
  watch: {
    pagination: {
      handler () {
        this.getProjects();
      },
      deep: true
    },
    advanced_view() {
      this.update_views();
    }
  },
  created() {
    this.avail_height = `${screen.availHeight - 200}px`;
    if (this.project){
      this.avail_height = `${screen.availHeight - 235}px`;
    }
    if (["xs", "sm"].indexOf(this.$vuetify.breakpoint.name) > -1){
      this.advanced_view = false;
      this.grouped_view = false;
      this.mobile_view = true;
      this.getProjectsMobile();
    }
  },
  destroyed() {
    clearInterval(this.jobs_tout);
  },
  methods: {
    expand_row(item){
      this.expanded.forEach((itm, itmx) => {
        this.expandedRef[itm.id] = itmx;
      })
      if (Object.prototype.hasOwnProperty.call(this.expandedRef, item.id)){
        let item_idx = this.expandedRef[item.id];
        this.expanded.splice(item_idx, 1);
        delete this.expandedRef[item.id];
      }else{
        this.expanded.push(item);
      }
      this.expandedRef = {};
    },
    row_clicked(item) {
      this.show_job_details(item);
    },
    getProjects() {
      clearInterval(this.jobs_tout);
      this.selected = [];
      this.projects = [];
      this.loading = true;
      this._getProjects();
      var my = this;
      this.jobs_tout = setInterval(function(){
        my._getProjects();
      }, 30000)
    },
    _getProjects() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.pagination;

      var sortQuery = "";
      if (sortBy && sortBy[0]){
        var orderStr = "asc";
        if (sortDesc && sortDesc[0]){
          orderStr = "desc";
        } 
        sortQuery = `&order_by=${sortBy[0]} ${orderStr}`
      }

      var flatListingQuery = ``;
      var subFilters = [];

      if (this.grouped_view){
        if (this.project){
          subFilters.push(`name $eq '${this.project}'`)
          if (this.search && this.search.length > 0){
            subFilters.push(`name $eq '${this.project}' $and submission_name $like '${this.search}%'`)
          }
        }else{
          subFilters.push(`submission_name $like '%'`);
          if (this.search && this.search.length > 0){
            subFilters.push(`submission_name $like '${this.search}%'`);
          }
        }
      }else{
        flatListingQuery = `&listing=flat`;
        if (this.project){
          subFilters.push(`project_name $eq '${this.project}'`)
          if (this.search && this.search.length > 0){
            subFilters.push(`project_name $eq '${this.project}' $and name $like '${this.search}%'`)
          }
        }else{
          if (this.search && this.search.length > 0){
            subFilters.push(`name $like '${this.search}%'`);
          }
        }
      }

      if (this.selected_status.length > 0){
        subFilters.push(`status $in (${this.selected_status.join(",")})`);
      }

      if (this.all_submissions){
        subFilters.push(`visibility $in (0,1)`);
      }

      let filterQuery = ``;
      if (subFilters.length){
        filterQuery = `&filter=${subFilters.join(' $and ')}`
      }
      
      axios.get(`https://${this.$buyerAPI}/projects?page=${page}&per_page=${itemsPerPage}${flatListingQuery}${sortQuery}${filterQuery}`)
      .then(resp => {
        var items = resp.data.data;
        var total = resp.data.total_all || (resp.data.per_page * resp.data.pages);
        this.projects = items;
        this.total_projects = total;
        this.pagination.totalItems = total;
        this.loading = false;
      })
      .catch(() => {          
        this.projects = [];
        this.total_projects = 0;
        this.loading = false;
      })
    },
    load_page(page) {
      this.loading_mobile = true;
      this.page = page;
      this._getProjectsMobile();
    },
    getProjectsMobile() {
      this.loading_mobile = true;
      clearInterval(this.jobs_tout);
      this.projects = [];
      this._getProjectsMobile();
      var my = this;
      this.jobs_tout = setInterval(function(){
        my._getProjectsMobile();
      }, 30000)
    },
    _getProjectsMobile() {
      let subFilters = [];
      let flatListingQuery = `&listing=flat`;
      if (this.project){
        subFilters.push(`project_name $eq '${this.project}'`)
        if (this.search && this.search.length > 0){
          subFilters.push(`project_name $eq '${this.project}' $and name $like '${this.search}%'`)
        }
      }else{
        if (this.search && this.search.length > 0){
          subFilters.push(`name $like '${this.search}%'`);
        }
      }

      let filterQuery = ``;
      if (subFilters.length){
        filterQuery = `&filter=${subFilters.join(' $and ')}`
      }

      axios.get(`https://${this.$buyerAPI}/projects?page=${this.page}&per_page=${this.itemsPerPage}${flatListingQuery}${filterQuery}`)
      .then(resp => {
        var items = resp.data.data;
        this.projects = items;
        this.page_length = resp.data.pages,
        this.total_visible = resp.data.per_page;
        this.loading_mobile = false;
      })
      .catch(() => {          
        this.projects = [];
        this.total_projects = 0;
        this.loading_mobile = false;
      })
    },
    search_job() {
      this.getProjects();
    },
    clear_search() {
      setTimeout(()=>{
        this.getProjects();
      })
    },
    set_status_filter() {
      this.getProjects();
    },
    set_visbility() {
      this.getProjects();
    },
    hide_selected() {
      let confirm_hide = confirm("Are you sure you want to hide the selected submissions?")
      if (!confirm_hide){
        return false;
      }

      let hide_projects = [];
      this.selected.forEach(sel_proj => {
        hide_projects.push(sel_proj.id);
      })

      let post_json = {
        project_ids: hide_projects
      }
      axios.post(`https://${this.$buyerAPI}/projects?action=hide`, post_json)
      .then(() => {
        this.getProjects();
      })
      .catch(error => {
          if (error.response){
              if (error.response.status == 401){
                  this.$session.destroy();
                  this.$router.push('/login');
              }else{
                this.service_plan_error = error.response.data;
              }
          }else{
              if (error.message == "Network Error"){
                  this.$session.destroy();
                  this.$router.push('/login');
              }else{
                this.service_plan_error = error.message;
              }
          }
      })
    },
    show_submission_summary(job_group){
      this.loading_summary = true;
      this._get_job_group_summary(job_group.id);
    },
    _get_job_group_summary(job_group_id) {
      axios.get(`https://${this.$buyerAPI}/projects/${job_group_id}`)
      .then(resp => {
        let resp_json = resp.data.data;
        this.submission_summary = resp_json.summary;
        setTimeout(() => {
          this.show_summary = true;
          this.loading_summary = false;
        }, 1000);
      })
      .catch(() => {
        this.loading_summary = false;
      })
    },
    show_job_details(job){
      this.job_details_obj = null;
      this.job_details_dialog = true;
      this.job_details_obj = job;
    },
    sortBy(prop) {
      this.projects.sort((a,b) => a[prop] < b[prop] ? -1 : 1)
    },
    format_time(){
      let now = new Date();
      let utc = new Date(now.getTime() + now.getTimezoneOffset() * 60000);
      now = now.toString().split(" "); now.splice(5)
      utc = utc.toString().split(" "); utc.splice(5)

      this.local_time_str = now.join(" ");
      this.utc_time_str = utc.join(" ");
    },
    to_local_datetime(utc_datetime){
      let utc_dt_string = `${utc_datetime}Z`;
      let local_dt = new Date(utc_dt_string);
      let year = local_dt.getFullYear();
      let month = local_dt.getMonth() < 9 ? `0${(local_dt.getMonth()+1)}` : (local_dt.getMonth()+1);
      let date = local_dt.getDate() < 10 ? `0${local_dt.getDate()}` : local_dt.getDate();
      let hours = local_dt.getHours() < 10 ? `0${local_dt.getHours()}` : local_dt.getHours();
      let mins = local_dt.getMinutes() < 10 ? `0${local_dt.getMinutes()}` : local_dt.getMinutes();
      let secs = local_dt.getSeconds() < 10 ? `0${local_dt.getSeconds()}` : local_dt.getSeconds();
      let local_st_string = `${year}-${month}-${date} ${hours}:${mins}:${secs}`;
      return local_st_string;
    },
    load_group_listing(){
      this.grouped_view = true;
      this.update_views();
      this.pagination.totalItems = 0;
      this.active = true;
      this.search_placeholder = "Search by submission name"
      this.getProjects();
    },
    load_flat_listing(){
      this.grouped_view = false;
      this.update_views();
      this.pagination.totalItems = 0;
      this.active = true;
      this.search_placeholder = "Search by job name"
      this.getProjects();
    },
    update_views(){
      let advanced_view = this.advanced_view;
      let flat_view = !this.grouped_view;
      this.$store.dispatch('update_user_views', {advanced_view, flat_view})
    },
    force_start_job(job_obj) {
      let confirm_force_start = confirm("Are you sure you want to force start this job?")
      if (!confirm_force_start){
        return false;
      }
      
      axios.post(`https://${this.$buyerAPI}/projects/${job_obj.group_id || job_obj.project_id}/jobs/${job_obj.id}?action=force-start`)
      .then(() => {
        this.refresh_parent();
      })
      .catch(() => {})
    },
    restart_job(job_obj) {
      this.restart_job_dialog = true;
      this.restart_job_obj = job_obj;
    },
    stop_job(job_obj) {
      this.stop_job_dialog = true;
      this.stop_job_obj = job_obj;
    },
    update_job_details_obj(new_obj){
      this.job_details_obj = new_obj;
    },
    close_job_details_dialog(){      
      this.job_details_obj = null;
      this.job_details_dialog = false;
    },
    close_stop_project_dialog(){      
      this.stop_project_dialog = false;
    },
    close_restart_job_dialog(){      
      this.restart_job_dialog = false;
      this.restart_job_obj = null;
    },
    close_stop_job_dialog(){      
      this.stop_job_dialog = false;
    },
    refresh_parent(){
      if (this.job_details_dialog){
        this.job_details_dialog = false;
      }
      let my = this;
      setTimeout(function(){
        my.getProjects();
      }, 2000)
    },
    close_stop_task_dialog(){      
      this.stop_task_dialog = false;
    },
    /*
    expandCollapse(){
      for (var i=0; i<expandCollapse.arguments.length; i++) 
      {
        var element = document.getElementById(expandCollapse.arguments[i]);
        element.style.display = (element.style.display == "none") ? "block" : "none";

        var img = document.getElementById(expandCollapse.arguments[i] + "img");
        img.src = (element.style.display == "none") ? "../common/expand.gif" : "../common/collapse.gif";
      }
    },
    */
    toggleVisibilityByClass(className){
      var elements = document.getElementsByTagName('*');
      for(var i = 0; i < elements.length; i++)
      {
        var node = elements.item(i);
        for(var j = 0; j < node.attributes.length; j++) 
        {
          if(node.attributes.item(j).nodeName == 'class') 
          {
            if(node.attributes.item(j).nodeValue.indexOf(className + ' ') == 0)
              node.style.display = ((node.style.display == "none") ? "block" : "none");
          }
        }
      }
    }
  }
}
</script>

<style>
.v-select{
  max-width: 275px;
}
.v-select .v-chip{
  margin: 0 4px !important;
  height: 24px;
  font-size: 12px;
}
.v-select .v-input__control{
  min-height:24px !important;
  max-width: 275px !important;
}
.v-select .v-input__slot{
  min-height:24px !important;
  width: 275px !important;
}
.v-select-list .v-list-item__action{
  margin: 5px 10px 5px 0 !important;
}
.v-data-table tr{
  cursor: pointer;
}
.v-data-table td{
  font-size: 0.625rem !important;
}
.v-datatable .project td:first-child{
  width: 24px;
  padding: 0 24px !important;
}
.v-datatable .project td:last-child{
  width: 12px;
  padding: 0 12px !important;
}
.v-datatable .job_detail td:first-child{
  width: 125px;
}
.project{
  cursor: pointer;
  border-left: 8px solid transparent;
}
.project_row_0{
  background-color: rgba(250, 243, 243, 0.05);
}
.project.Running, .job_detail.Running{
  border-left: 8px solid #4CAF50;
}
.project.Completed, .job_detail.Completed{
  border-left: 8px solid #1976D2;
}
.project.Terminated, .job_detail.Terminated{
  border-left: 8px solid #FFC107;
}
.project.Failed, .job_detail.Failed{
  border-left: 8px solid #FF5252;
}
.mjob.Running{
  border-left: 4px solid #4CAF50;
}
.mjob.Completed{
  border-left: 4px solid #1976D2;
}
.mjob{
  border-left: 4px solid #555555;
}
.mjob.Terminated, .mjob.Terminating,
.mjob.Stopped, .mjob.Stopping,
.mjob.Suspended, .mjob.Suspending{
  border-left: 4px solid #FFC107;
}
.mjob.Failed{
  border-left: 4px solid #FF5252;
}
.jobs.Running{
  border-left: 36px solid #4CAF50;
}
.jobs.Completed{
  border-left: 36px solid #1976D2;
}
.jobs{
  border-left: 36px solid #555555;
}
.job_headers{
  border-left: 36px solid #616161;
}
.job_headers .v-card{
  background: #616161 !important;
}
.jobs.Terminated, .jobs.Terminating,
.jobs.Stopped, .jobs.Stopping,
.jobs.Suspended, .jobs.Suspending{
  border-left: 36px solid #FFC107;
}
.jobs.Failed{
  border-left: 36px solid #FF5252;
}
.v-progress-circular.Running{
  color: #4CAF50 !important;
}
.v-progress-circular.Completed{
  color: #1976D2 !important;
}
.v-progress-circular.Terminated, .v-progress-circular.Terminating,
.v-progress-circular.Stopped, .v-progress-circular.Stopping,
.v-progress-circular.Suspended, .v-progress-circular.Suspending{
  color: #FFC107 !important;
}
.v-progress-circular.Failed{
  color: #FF5252 !important;
}
.v-progress-circular{
  font-size: .875em !important;
  vertical-align: top;
}
.status.Running, .v-chip.Running{
  background: #4CAF50 !important;
}
.status.Completed, .v-chip.Completed{
  background: #1976D2 !important;
}
.status.Terminated, .v-chip.Terminated,
.status.Terminating, .v-chip.Terminating,
.status.Stopped, .v-chip.Stopped
.status.Stopping, .v-chip.Stopping,
.status.Suspended, .v-chip.Suspended,
.status.Suspending, .v-chip.Suspending{
  background: #FFC107 !important;
}
.status.Failed, .v-chip.Failed{
  background: #FF5252 !important;
}
.v-expansion-panel__header{
  padding:0
}
.v-card.jobs:hover {
  background: #616161;
  cursor: pointer;
}
.v-dialog > .v-card{
  background: #303030;
}
tbody tr.job_detail:nth-child(odd) {
   background-color: rgba(250, 243, 243, 0.05);
 }
.project_actions > .v-icon, .job_actions > .v-icon{
  color: #acd0b4;
}
.job_id{
  font-size: .675rem !important;
}
.v-card > header{
  flex: unset;
}
.v-data-table td, .v-data-table th {
  padding: 4px 4px !important;
  vertical-align: baseline;
}
.v-data-table.ungrouped-table tr{
  cursor: pointer;
}
.v-data-table th.datetime, .v-data-table td.datetime {
  width:88px !important;
}
.v-list-group.mprojects .v-list-item__icon.v-list-group__header__append-icon {
  min-width: unset !important;
  margin-left: 0;
}
.v-list-group.mprojects > div{
  padding: 0 !important;
}
.v-list-item{
  min-height:32px !important;
}
.v-input .v-input__append-inner{
  margin:0 !important;
}
.task_log{
  overflow: scroll;
}
.no-transition {
  transition: none
}

.sub_status{
  height: 18px !important;
  width: 18px !important;
}
.v-input--selection-controls__input > i::before{
  font-size: 18px;
}

</style>